import React from 'react';
import './Parents.css';

function Parents() {
  return (
    <div className="container">
      <h1 className="page-title">Родители</h1>
      
      <section className="parents-section">
        <div className="parents-card">
          <div className="parent-info">
            <div className="parent-photo-placeholder">
              <span>Фото</span>
            </div>
            <div className="parent-details">
              <h2>Анастасия Скрипунова</h2>
              <p>Мама Софии</p>
            </div>
          </div>
          <div className="parent-bio">
            <p>
              Анастасия — заботливая и внимательная мама, которая всегда находит 
              время на игры и общение с дочерью. Она любит читать Софии книги и гулять в парке.
            </p>
          </div>
        </div>
        
        <div className="parents-card">
          <div className="parent-info">
            <div className="parent-photo-placeholder">
              <span>Фото</span>
            </div>
            <div className="parent-details">
              <h2>Юрий Скрипунов</h2>
              <p>Папа Софии</p>
            </div>
          </div>
          <div className="parent-bio">
            <p>
              Юрий — заботливый отец, который обожает проводить время с дочерью. 
              Он часто берет Софию на руки и рассказывает ей интересные истории.
            </p>
          </div>
        </div>
      </section>
      
      <section className="rules-section">
        <h2>Шуточные правила жизни с новорожденной</h2>
        <div className="rules-list">
          <div className="rule-card">
            <div className="rule-number">1</div>
            <div className="rule-text">
              <h3>Сон — это роскошь</h3>
              <p>Забудьте о 8-часовом сне. Теперь вы будете спать как супергерой — короткими промежутками, но очень крепко!</p>
            </div>
          </div>
          
          <div className="rule-card">
            <div className="rule-number">2</div>
            <div className="rule-text">
              <h3>Кофе — ваш новый лучший друг</h3>
              <p>Если раньше вы пили кофе просто так, теперь это ваше основное средство для выживания.</p>
            </div>
          </div>
          
          <div className="rule-card">
            <div className="rule-number">3</div>
            <div className="rule-text">
              <h3>Время течет иначе</h3>
              <p>Теперь день измеряется не часами, а кормлениями, сменами подгузников и короткими периодами сна.</p>
            </div>
          </div>
          
          <div className="rule-card">
            <div className="rule-number">4</div>
            <div className="rule-text">
              <h3>Мастерство одевания одной рукой</h3>
              <p>Вы научитесь одеваться, готовить еду и даже отвечать на электронные письма, держа ребенка на руках.</p>
            </div>
          </div>
          
          <div className="rule-card">
            <div className="rule-number">5</div>
            <div className="rule-text">
              <h3>Улыбка ребенка стоит всего</h3>
              <p>Несмотря на все трудности, одна улыбка малыша заставит вас забыть обо всех бессонных ночах.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Parents; 